<template>
  <div>
    <b-row>
      <b-col>
        <h5>Filtrar por</h5>
      </b-col>
      <b-col sm="2">
        <downloadExcel
          class="btn btn-warning col-sm-12"
          :data="filteredItems()"
          worksheet="Abonos"
          name="analisis-abonos-segmentado.xls"
          :fields="json_fields"
          :before-generate="startDownload()"
          :before-finish="finishDownload()"
        >Exportar</downloadExcel>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">
        <b-form-group>
          <label class="mb-0">Año</label>
          <b-form-select v-model="year" @change="getDebtors()">
            <template slot="first">
              <option :value="null">-- Por favor seleccione --</option>
            </template>
            <option v-for="item in lstYears" :key="item.year" :value="item.year">{{ item.year }}</option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group>
          <label class="mb-0" for="cmbCuenta">Cliente</label>
          <b-form-select v-model="customer_id_filter" id="cmbCuenta" @change="getDebtors()">
            <template slot="first">
              <option :value="null">-- Por favor seleccione una opción --</option>
            </template>

            <option
              v-for="item in lstCustomers"
              :key="item.id"
              :value="item.id"
            >{{ item.business_name }}</option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group>
          <label for="cmbStaff" class="mb-0">Comercial</label>
          <b-form-select v-model="customer_staff_id_filter" id="cmbStaff" @change="getDebtors()">
            <template slot="first">
              <option :value="null" >-- Por favor seleccione una opción --</option>
            </template>
            <option
              v-for="item in lstComercialStaffs"
              :key="item.id"
              :value="item.id"
            >{{ item.name }} {{ item.last_name }} ({{ item.type_name }})</option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group>
          <label for="cmbEstado" class="mb-0">Estado</label>
          <b-form-select v-model="status_filter" id="cmbEstado" @change="getDebtors()">
            <template slot="first">
              <option :value="null">-- Estado --</option>
            </template>
            <option value="P">Pausado</option>
            <option value="A">Activo</option>
            <option value="C">Cerrado</option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="3">
        <b-form-group>
          <label for="cmbEtapa" class="mb-0">Etapa de cobro</label>
          <b-form-select v-model="process_id_filter" id="cmbEtapa" @change="getDebtors()" :disabled="true">
            <template slot="first">
              <option :value="null" >-- Etapa de cobro --</option>
            </template>
            <option v-for="item in lstProcess" :key="item.id" :value="item.id">{{ item.name }}</option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group>
          <label class="mb-0">Tipificación</label>
          <b-form-select v-model="type_filter" @change="getDebtors()">
            <template slot="first">
              <option :value="null">-- Tipificación --</option>
            </template>
            <option v-for="item in lstType" :key="item.id" :value="item.id">{{ item.name }}</option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group>
          <label class="mb-0">Cobrador / Abogado</label>
          <b-form-select
            v-model="staff_id_filter"
            @change="getDebtors()"
            :disabled="role_id == 1 || role_id == 8 ? false : true"
          >
            <template slot="first">
              <option :value="null">-- Por favor seleccione una opción --</option>
            </template>
            <option
              v-for="item in lstStaffs"
              :key="item.id"
              :value="item.id"
            >{{ item.name }} {{ item.last_name }} ({{ item.type_name }})</option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">
            <div>
              <b-table
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                responsive
                :items="filteredItems()"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                default-sort="month"
                default-sort-direction="asc"
              >
                <template slot="capital_to_recover" slot-scope="data">
                  <div class="text-right">${{formatPrice(data.item.capital_to_recover)}}</div>
                </template>
              </b-table>
            </div>
            <hr />
            <div class="row">
              <div
                class="col-sm-4"
              >Mostrando {{getRowCount(items) > (perPage * currentPage) ? perPage * currentPage : getRowCount(items)}} de {{getRowCount(items)}} registros</div>
              <div class="col-sm-8">
                <nav>
                  <b-pagination
                    size="sm"
                    align="right"
                    :total-rows="getRowCount(items)"
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Anterior"
                    next-text="Siguiente"
                    :limit="10"
                  />
                </nav>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "AnalysisBalancesRecover",
  components: {},
  props: {
    caption: {
      type: String,
      default: "ABONOS POSIBLES SEGÚN SEGMENTO",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      auth: localStorage.getItem("auth"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      fields: [
        { key: "type_name", label: "Tipificación", sortable: true },

        { key: "to_5", label: "5", sortable: true },
        { key: "to_10", label: "10", sortable: true },
        { key: "to_15", label: "15", sortable: true },
        { key: "to_25", label: "25", sortable: true },
        { key: "to_30", label: "30", sortable: true },
        { key: "to_35", label: "35", sortable: true },
        { key: "to_40", label: "40", sortable: true },
        { key: "to_45", label: "45", sortable: true },
        { key: "to_50", label: "50", sortable: true },
        { key: "to_55", label: "55", sortable: true },
        { key: "to_60", label: "60", sortable: true },
        { key: "to_65", label: "65", sortable: true },
        { key: "to_70", label: "70", sortable: true },
        { key: "to_75", label: "75", sortable: true },
        { key: "to_80", label: "80", sortable: true },
        { key: "to_100", label: "100", sortable: true },
        { key: "to_120", label: "120", sortable: true },
        { key: "to_150", label: "150", sortable: true },
        { key: "to_200", label: "+200", sortable: true },
        {
          key: "capital_to_recover",
          label: "Total por cobrar",
          sortable: true,
        },
      ],
      json_fields: {
        Tipificación: "type_name",
        "5": "to_5",
        "10": "to_10",
        "15": "to_15",
        "25": "to_25",
        "30": "to_30",
        "35": "to_35",
        "40": "to_40",
        "45": "to_45",
        "50": "to_50",
        "55": "to_55",
        "60": "to_60",
        "65": "to_65",
        "70": "to_70",
        "75": "to_75",
        "80": "to_80",
        "100": "to_100",
        "120": "to_120",
        "150": "to_150",
        "200": "to_200",
        "Total por cobrar": "capital_to_recover",
      },
      items: [],
      pagination: {},
      filter: null,
      tableData: [],
      tableHeader: [],
      errores: [],
      mostrarResumen: false,
      rowCount: -1,
      //

      // FILTROS DE BUSQUEDA
      year: null,
      staff_id_filter: null,
      customer_id_filter: null,
      customer_staff_id_filter: null,
      status_filter: "A",
      type_filter: null,
      process_id_filter: 1,
      // LISTAS PARA LOS FILTROS

      lstStaffs: [],
      lstComercialStaffs: [],
      lstCustomers: [],
      lstYears: [],
      lstType: [],
      lstProcess: [],

      summary: {
        capital_recovered: 0,
        fees_recovered: 0,
        interests_recovered: 0,
        total_recovered: 0,
      },

      // PAGINACIÓN DE VUE
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
    };
  },
  mounted() {
    this.initParameters();
    this.getDebtors();
  },
  computed: {},
  methods: {
    initParameters() {
      // var auth = localStorage.getItem("auth");
      // auth = JSON.parse(auth);
      // this.isCustomer = authAux[0].customer_id != null ? true : false;

      // LISTA DE CUENTAS
      var auth = localStorage.getItem("auth");
      let authAux = JSON.parse(auth);
      this.isCustomer = authAux[0].customer_id != null ? true : false;
      this.staff_id_filter = this.role_id == 1 || this.role_id == 8 ? null : authAux[0].staff_id;

      let url = `${this.$urlApi}customers/staff?token=${this.token}`;

      if (authAux[0].is_admin === "N") {
        authAux[0].filter_staff_id = authAux[0].staff_id;
      }
      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          (response) => {
            // console.log(response);
            this.lstCustomers = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        );

      //LISTADO DE STAFF'S, 43: PREJURIDICO
      this.$http.get(`${this.$urlApi}staffs/type/43?token=${this.token}`).then(
        (response) => {
          this.lstStaffs = response.data.data;
          // console.log(response.data.data);
        },
        (error) => {
          console.log(error);
        }
      );

      //LISTADO DE STAFF'S, 42: COMERCIAL
      this.$http.get(`${this.$urlApi}staffs/type/42?token=${this.token}`).then(
        (response) => {
          this.lstComercialStaffs = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // AÑOS
      this.$http.get(`${this.$urlApi}payments/years?token=${this.token}`).then(
        (response) => {
          // console.log(response);
          this.lstYears = response.data.data;
          // this.lstYears.push({ year: 2021 });
          // console.log(this.lstYears);
        },
        (error) => {
          console.log(error);
        }
      );

      // TIPIFICACIÓN DEUDOR
      this.$http.get(`${this.$urlApi}parameters/15?token=${this.token}`).then(
        (response) => {
          this.lstType = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // PROCESOS
      this.$http.get(`${this.$urlApi}process?token=${this.token}`).then(
        (response) => {
          this.lstProcess = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    filteredItems() {
      return this.items.filter((item) => {
        let keep = true;

        // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
        this.fieldKeys().forEach((key) => {
          keep =
            keep &&
            (this.selectVal[key] === undefined ||
              item[key] === this.selectVal[key]);
        });
        return keep;
      });
    },
    fieldKeys() {
      let keys = [];
      return keys;

      if (this.items[0] === undefined) return null;
      else return Object.keys(this.items[0]);
    },
    options() {
      // This could be simplified if the select was it's own component.
      const options = {};
      //console.log(this.fieldKeys())
      this.fieldKeys().forEach((key) => {
        const vals = this.items.map((item) => item[key]);
        // Cheap and efficient unique.
        options[key] = Array.from(new Set(vals));
      });

      return options;
    },

    getDebtors: function () {
      showLoader();

      let authAux = JSON.parse(this.auth);
      authAux[0].year = this.year;
      authAux[0].staff_id_filter = this.staff_id_filter;
      authAux[0].customer_staff_id_filter = this.customer_staff_id_filter;
      authAux[0].customer_id = this.customer_id_filter;
      authAux[0].status = this.status_filter;
      authAux[0].type = this.type_filter;
      authAux[0].process_id = this.process_id_filter;

      this.$http
        .post(
          `${this.$urlApi}debtors/indicators/analysisbalancesrecover?token=${this.token}`,
          JSON.stringify(authAux),
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then(
          function (response) {
            console.clear();
            console.log(response);
            this.items = response.data.data;
            // this.summary = response.data.summary;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    startDownload() {
      // showLoader();
    },
    finishDownload() {
      // hideLoader();
    },
    formatPrice(value) {
      let val = Math.trunc(value);
      // let val = (valueAux / 1).toFixed(2).replace(".", ",");
      // console.log(valueAux);
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getRowCount(items) {
      return items.length;
    },
    getNameMonth(value) {
      return getNameMonth(value);
    },
  },
};
</script>
